<template>
  <v-app>
    <v-snackbar v-model="snackbar" :color="color.snackbar" top="top">
      {{ message }}
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-row fill-height align="center" justify="center">
      <v-col cols="12" sm="8" md="4">
        <v-card class="elevation-12">
          <v-toolbar color="white" flat>
            <v-toolbar-title align="center" justify="center"
              >Login</v-toolbar-title
            >
            <v-spacer />
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-text-field
                label="Email"
                name="Email"
                v-model="email"
                :rules="emailRules"
                prepend-icon="email"
                type="text"
              />

              <v-text-field
                id="password"
                v-model="password"
                :rules="passRules"
                label="Password"
                name="password"
                prepend-icon="lock"
                type="password"
              />
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="green lighten-1" outlined @click="Login">Login</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-app>
</template>

<script>
export default {
  props: {
    source: String
  },
  data() {
    return {
      eula: true,
      email: null,
      password: null,
      color: { snackbar: '' },
      snackbar: false,
      message: null,
      response: null,
      emailRules: [v => !!v || 'Email wajib diisi'],
      passRules: [v => !!v || 'Password wajib diisi']
    };
  },
  methods: {
    setAlert: 'alert/set',
    async Login() {
      let formData = new FormData();
      formData.append('email', this.email);
      formData.append('password', this.password);

      this.$req
        .post(this.$root.$baseapi.user+'/user/v3/biz/login', formData)
        .then(response => {
          window.localStorage.setItem(
            'user',
            JSON.stringify(response.data.data[0])
          );
          window.localStorage.setItem('token', response.data.data[0].token);
          window.localStorage.setItem('id', response.data.data[0].id);
          console.log('resp ', response.data.data);
          this.$store.commit('SET_USER', response.data.data[0]);
          this.$store.commit('SET_TOKEN', response.data.data[0].token);
          this.$router.push(
            response.data.data.redirect
              ? response.data.data.redirect
              : '/dashboard'
          );
        })
        .catch(error => {
          this.color.snackbar = 'error';
          this.message = error.response.data.api_message;
          this.snackbar = true;
        });

      // const response = await this.$req.post(this.$root.$baseapi.user+'/user/v3/biz/login', formData);

      // console.log('status', response.status);
      // if (response.status == 200) {
      //   console.log('token', response.data.data[0].token);
      //   window.localStorage.setItem(
      //     'user',
      //     JSON.stringify(response.data.data[0])
      //   );
      //   window.localStorage.setItem('token', response.data.data[0].token);

      //   this.$store.commit('SET_USER', response.data.data[0]);
      //   this.$store.commit('SET_TOKEN', response.data.data[0].token);
      //   this.$router.push(response.redirect ? response.redirect : '/dashboard');
      // } else {
      //   this.setAlert({
      //     status: true,
      //     color: 'success',
      //     text: 'Login successfully'
      //   });
      //   this.message = response.api_message;
      // }
    }
  }
};
</script>
s
